<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-calendar"></i> 个人设置
                </el-breadcrumb-item>
                <el-breadcrumb-item>企业信息</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="form-box" style="width:100%">
                <el-form ref="form" :model="form" :rules="rules" label-width="180px">
					<el-tabs v-model="activeName" type="card">
						<el-tab-pane label="基本信息" name="baseTab" style="width:50%;margin-top:10px">
							<el-form-item label="公司全称" prop="applyCompanyConfig.fullName">
								<el-input v-model="form.applyCompanyConfig.fullName" placeholder="公司全称"></el-input>
							</el-form-item>
							<el-form-item label="税务登记号" prop="applyCompanyConfig.taxNo">
								<el-input v-model="form.applyCompanyConfig.taxNo" placeholder="税务登记号"></el-input>
							</el-form-item>
							<el-form-item label="注册地址" prop="applyCompanyConfig.address">
								<el-input v-model="form.applyCompanyConfig.address" placeholder="注册地址"></el-input>
							</el-form-item>
							<el-form-item label="生产经营地址" prop="applyCompanyConfig.produceAddress">
								<el-input v-model="form.applyCompanyConfig.produceAddress" placeholder="生产经营地址"></el-input>
							</el-form-item>
							<el-form-item label="法人代表" prop="applyCompanyConfig.legalPerson">
								<el-input v-model="form.applyCompanyConfig.legalPerson" placeholder="联系人"></el-input>
							</el-form-item>
							<el-form-item label="联系人" prop="contact">
								<el-input v-model="form.contact" placeholder="联系人"></el-input>
							</el-form-item>
							<el-form-item label="公司电话" prop="tel">
								<el-input v-model="form.tel" placeholder="公司电话"></el-input>
							</el-form-item>
							<el-form-item label="公司网址" prop="applyCompanyConfig.website">
								<el-input v-model="form.applyCompanyConfig.website" placeholder="公司网址"></el-input>
							</el-form-item>
						</el-tab-pane>
						<el-tab-pane label="运营信息" name="operateTab" style="width:50%;margin-top:10px" v-if="controll['operate']">
							<el-form-item label="免邮金额" prop="applyCompanyConfig.freePostageAmount">
								<el-input v-model="form.applyCompanyConfig.freePostageAmount" placeholder="免邮金额"></el-input>
							</el-form-item>
							<el-form-item label="最小利润率" prop="applyCompanyConfig.minProfit">
								<el-input v-model="form.applyCompanyConfig.minProfit" placeholder="最小利润率(1.05：表示5个点利润)，产品入库将按最小利润率计算最低出库价格（进价*1.05=最低出库价）"></el-input>
							</el-form-item>
							<el-form-item label="默认成本比率" prop="applyCompanyConfig.defaultCostRate">
								<el-input v-model="form.applyCompanyConfig.defaultCostRate" placeholder="默认成本比率(1.01:表示进价的101%为成本)"></el-input>
							</el-form-item>
							<el-form-item label="不含税成本比率" prop="applyCompanyConfig.taxExcludedCostRate" v-if=form.showNoTax>
								<el-input v-model="form.applyCompanyConfig.taxExcludedCostRate" placeholder="不含税成本比率(0.9:表示进价的90%为成本)"></el-input>
							</el-form-item>
							<el-form-item label="不计提成利润点" prop="applyCompanyConfig.noChargedRate">
								<el-input v-model="form.applyCompanyConfig.noChargedRate" placeholder="不计提成利润点(1.03:表示理论低于3个点，不算提成)"></el-input>
							</el-form-item>
							<el-form-item label="客户联系提醒周期" prop="applyCompanyConfig.customerContactCycle">
								<el-input v-model="form.applyCompanyConfig.customerContactCycle" placeholder="超过周期时，显示上着色提醒"></el-input>
							</el-form-item>
						</el-tab-pane>
						<el-tab-pane label="税务信息" name="taxTab" style="width:50%;margin-top:10px"  v-if="controll['tax']">
							<el-form-item label="开票方式" prop="applyCompanyConfig.invoicingType">
								<el-select v-model="form.applyCompanyConfig.invoicingType">
									<el-option :key="0" label="税务局官网全电发票" :value="0"></el-option>
									<el-option :key="1" label="UKey版开票" :value="1"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="发票最大金额" prop="applyCompanyConfig.invoiceAmountMax" v-if="form.invoicingType==1">
								<el-input v-model="form.applyCompanyConfig.invoiceAmountMax" placeholder="发票最大金额"></el-input>
							</el-form-item>
							<el-form-item label="增值税率" prop="applyCompanyConfig.taxRate">
								<el-input v-model="form.applyCompanyConfig.taxRate" placeholder="增值税率"></el-input>
							</el-form-item>
							<el-form-item label="城市维护建设税率" prop="applyCompanyConfig.cityAdditionalTaxRate">
								<el-input v-model="form.applyCompanyConfig.cityAdditionalTaxRate" placeholder="城市维护建设税率"></el-input>
							</el-form-item>
							<el-form-item label="教育附加税率" prop="applyCompanyConfig.educationAdditionalTaxRate">
								<el-input v-model="form.applyCompanyConfig.educationAdditionalTaxRate" placeholder="教育附加税率"></el-input>
							</el-form-item>
							<el-form-item label="地方教育附加税率" prop="applyCompanyConfig.localEducationAdditionalTaxRate">
								<el-input v-model="form.applyCompanyConfig.localEducationAdditionalTaxRate" placeholder="地方教育附加税率"></el-input>
							</el-form-item>
							<el-form-item label="商品税目" prop="applyCompanyConfig.taxProductName" v-if="form.invoicingType==1">
								<el-input v-model="form.applyCompanyConfig.taxProductName" placeholder="商品税目"></el-input>
							</el-form-item>
							<el-form-item label="价格方式" prop="applyCompanyConfig.taxPriceType" v-if="form.invoicingType==1">
								<el-input v-model="form.applyCompanyConfig.taxPriceType" placeholder="价格方式"></el-input>
							</el-form-item>
							<el-form-item label="税收分类编码版本号" prop="applyCompanyConfig.taxVersion" v-if="form.invoicingType==1">
								<el-input v-model="form.applyCompanyConfig.taxVersion" placeholder="税收分类编码版本号"></el-input>
							</el-form-item>
							<el-form-item label="运费项目开票方式" prop="applyCompanyConfig.freightBillingType">
								<el-select v-model="form.applyCompanyConfig.freightBillingType">
									<el-option :key="0" label="独立开票" :value="0"></el-option>
									<el-option :key="1" label="分摊到多个产品项中" :value="1"></el-option>
									<el-option :key="2" label="合并到末尾产品项" :value="2"></el-option>
								</el-select>
							</el-form-item>
						</el-tab-pane>
						<el-tab-pane label="财务信息" name="accountingTab" style="margin-top:10px"  v-if="controll['accounting']">
							<div style="width:50%;">
								<el-form-item label="所属行业" prop="applyCompanyConfig.industry">
									<el-input v-model="form.applyCompanyConfig.industry" placeholder="所属行业"></el-input>
								</el-form-item>
								<el-form-item label="企业登记注册类型" prop="applyCompanyConfig.companyType">
									<el-input v-model="form.applyCompanyConfig.companyType" placeholder="企业登记注册类型"></el-input>
								</el-form-item>
							</div>
							<el-row>
								<el-col :span="12">
									<el-form-item label="对公银行名称" prop="applyCompanyConfig.bankName">
										<el-input v-model="form.applyCompanyConfig.bankName" placeholder="对公银行名称"></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<div style = "margin-left:10px;margin-top:10px;">
										<el-link type="primary" :underline="false" @click="handleMoreBrank">更多对公账户...</el-link>
									</div>
								</el-col>
							</el-row>
							<div style="width:50%;">
								<el-form-item label="对公银行账号" prop="applyCompanyConfig.bankNo">
									<el-input v-model="form.applyCompanyConfig.bankNo" placeholder="对公银行账号"></el-input>
								</el-form-item>
								<el-form-item label="主管税务机关" prop="applyCompanyConfig.taxationBureau">
									<el-input v-model="form.applyCompanyConfig.taxationBureau" placeholder="主管税务机关"></el-input>
								</el-form-item>
								<el-form-item label="记账编号格式" prop="applyCompanyConfig.accountingNo">
									<el-input v-model="form.applyCompanyConfig.accountingNo" placeholder="记账编号格式"></el-input>
								</el-form-item>
								<el-form-item label="财务授权人" prop="applyCompanyConfig.authorizedPerson">
									<el-input v-model="form.applyCompanyConfig.authorizedPerson" placeholder="财务授权人"></el-input>
								</el-form-item>
								<el-form-item label="制单" prop="applyCompanyConfig.creator">
									<el-input v-model="form.applyCompanyConfig.creator" placeholder="制单"></el-input>
								</el-form-item>
								<el-form-item label="审核" prop="applyCompanyConfig.reviewer">
									<el-input v-model="form.applyCompanyConfig.reviewer" placeholder="审核"></el-input>
								</el-form-item>
								<el-form-item label="出纳" prop="applyCompanyConfig.cashier">
									<el-input v-model="form.applyCompanyConfig.cashier" placeholder="出纳"></el-input>
								</el-form-item>
								<el-form-item label="记账人" prop="applyCompanyConfig.bookkeeper">
									<el-input v-model="form.applyCompanyConfig.bookkeeper" placeholder="记账人"></el-input>
								</el-form-item>
								<el-form-item label="会计主管" prop="applyCompanyConfig.accounting">
									<el-input v-model="form.applyCompanyConfig.accounting" placeholder="会计主管"></el-input>
								</el-form-item>
							</div>
						</el-tab-pane>
						<el-tab-pane label="模板信息" name="templateTab" style="margin-top:10px" v-if="controll['template']">
							<el-tabs v-model="templateActiveName" tab-position="right">
								<el-tab-pane label="模板设置" name="templateSetTab" style="width:60%">
									<el-form-item label="采购合同模板" prop="applyCompanyConfig.purchaseContractTemplateId">
										<el-select v-model="form.applyCompanyConfig.purchaseContractTemplateId" placeholder="请选择采购合同模板" filterable>
											<el-option key="" label="请选择采购合同模板" value=""></el-option>
											<el-option v-for="item in purchaseContractTemplateKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
										</el-select>
									</el-form-item>
									<el-form-item label="采购合同编号格式" prop="applyCompanyConfig.purchaseContractNoFormat">
										<el-input v-model="form.applyCompanyConfig.purchaseContractNoFormat" placeholder="格式：CG{date}{no}，{data}和{no}为固定占位符，将被替换"></el-input>
									</el-form-item>
									<el-form-item label="销售合同模板" prop="applyCompanyConfig.shipmentContractTemplateId">
										<el-select v-model="form.applyCompanyConfig.shipmentContractTemplateId" placeholder="请选择销售合同模板" filterable>
											<el-option key="" label="请选择销售合同模板" value=""></el-option>
											<el-option v-for="item in shipmentContractTemplateKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
										</el-select>
									</el-form-item>
									<el-form-item label="销售合同编号格式" prop="applyCompanyConfig.shipmentContractNoFormat">
										<el-input v-model="form.applyCompanyConfig.shipmentContractNoFormat" placeholder="格式：XS{date}{no}，{data}和{no}为固定占位符，将被替换"></el-input>
									</el-form-item>
									<el-form-item label="报价单模板" prop="applyCompanyConfig.quotationTemplateId">
										<el-select v-model="form.applyCompanyConfig.quotationTemplateId" placeholder="请选择报价单模板" filterable>
											<el-option key="" label="请选择报价单模板" value=""></el-option>
											<el-option v-for="item in quotationTemplateKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
										</el-select>
									</el-form-item>
									<el-form-item label="报价单编号格式" prop="applyCompanyConfig.quotationNoFormat">
										<el-input v-model="form.applyCompanyConfig.quotationNoFormat" placeholder="格式：BJ{date}{no}，{data}和{no}为固定占位符，将被替换"></el-input>
									</el-form-item>
									<el-form-item label="出货单模板" prop="applyCompanyConfig.outStockTemplateId">
										<el-select v-model="form.applyCompanyConfig.outStockTemplateId" placeholder="请选择出货单模板" filterable>
											<el-option key="" label="请选择出货单模板" value=""></el-option>
											<el-option v-for="item in outStockTemplateKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
										</el-select>
									</el-form-item>
									<el-form-item label="出货单编号格式" prop="applyCompanyConfig.outStockNoFormat">
										<el-input v-model="form.applyCompanyConfig.outStockNoFormat" placeholder="格式：OS{date}{no}，{data}和{no}为固定占位符，将被替换"></el-input>
									</el-form-item>
									<el-form-item label="指定出货单制单人" prop="applyCompanyConfig.documentMaker">
										<el-input v-model="form.applyCompanyConfig.documentMaker"></el-input>
									</el-form-item>
									<el-form-item label="指定出货单仓库" prop="applyCompanyConfig.storeman">
										<el-input v-model="form.applyCompanyConfig.storeman"></el-input>
									</el-form-item>
									<el-form-item label="对账单模板" prop="applyCompanyConfig.reconciliationTemplateId">
										<el-select v-model="form.applyCompanyConfig.reconciliationTemplateId" placeholder="请选择对账单模板" filterable>
											<el-option key="" label="请选择对账单模板" value=""></el-option>
											<el-option v-for="item in reconciliationTemplateKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
										</el-select>
									</el-form-item>
									<el-form-item label="公司logo" prop="applyCompanyConfig.logo">
										<el-upload
											class="upload-demo"
											:action= "uploadUrl"
											:before-upload="beforeUpload"
											:on-success="uploadLogoSuccess"
											:on-remove="handleLogoRemove"
											:file-list="logoFileList"
											accept=".png,.jpg"
											list-type="picture">
											<el-button size="small" type="primary">点击上传</el-button>
											<div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
										</el-upload>
									</el-form-item>
									<el-form-item label="合同印章" prop="applyCompanyConfig.seal">
										<el-upload
											class="upload-demo"
											:action= "uploadUrl"
											:before-upload="beforeUpload"
											:on-success="uploadSealSuccess"
											:on-remove="handleSealRemove"
											:file-list="sealFileList"
											accept=".png,.jpg"
											list-type="picture">
											<el-button size="small" type="primary">点击上传</el-button>
											<div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
										</el-upload>
									</el-form-item>
									<el-form-item label="出货印章" prop="applyCompanyConfig.shippingSeal">
										<el-upload
											class="upload-demo"
											:action= "uploadUrl"
											:before-upload="beforeUpload"
											:on-success="uploadShippingSealSuccess"
											:on-remove="handleShippingSealRemove"
											:file-list="shippingSealFileList"
											accept=".png,.jpg"
											list-type="picture">
											<el-button size="small" type="primary">点击上传</el-button>
											<div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
										</el-upload>
									</el-form-item>
								</el-tab-pane>
								<el-tab-pane label="销售合同自定义条款" name="salesTermsTab">
									<el-input type=textarea :rows=23 v-model="form.applyCompanyTextConfig.salesTerms"> </el-input>
								</el-tab-pane>
								<el-tab-pane label="报价单自定义条款" name="quotationTermsTab">
									<el-input type=textarea :rows=23 v-model="form.applyCompanyTextConfig.quotationTerms"> </el-input>
								</el-tab-pane>
							</el-tabs>
							
							
						</el-tab-pane>
						<el-tab-pane label="数据信息" name="dataTab" style="width:50%;margin-top:10px" v-if="controll['data']">
							<el-form-item label="显示撤销订单" prop="applyCompanyConfig.showCancelOrder">
								<el-switch v-model="form.applyCompanyConfig.showCancelOrder"></el-switch>
							</el-form-item>
							<el-form-item label="同步更新报价" prop="applyCompanyConfig.changeOfferByPurchase">
								<el-switch v-model="form.applyCompanyConfig.changeOfferByPurchase"></el-switch>
							</el-form-item>
							<el-form-item label="订单校验" prop="applyCompanyConfig.orderCheck">
								<el-switch v-model="form.applyCompanyConfig.orderCheck"></el-switch>
							</el-form-item>
							<el-form-item label="出库排货" prop="applyCompanyConfig.outStockSort">
								<el-switch v-model="form.applyCompanyConfig.outStockSort"></el-switch>
							</el-form-item>
							<el-form-item label="排货方式" prop="applyCompanyConfig.outStockSortType" v-if="form.outStockSort">
								<el-select v-model="form.applyCompanyConfig.outStockSortType">
									<el-option :key="0" label="按订单时间" :value="0"></el-option>
									<el-option :key="1" label="按订单单价" :value="1"></el-option>
									<el-option :key="2" label="按订单付款时间" :value="2"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="显示未税数据" prop="applyCompanyConfig.showNoTax">
								<el-switch v-model="form.applyCompanyConfig.showNoTax"></el-switch>
							</el-form-item>
						</el-tab-pane>
						<el-tab-pane label="库存设置" name="StockSetTab" style="width:50%;margin-top:10px" v-if="controll['stock-set']">
							<el-form-item label="显示进价" prop="applyCompanyConfig.showPurchasePrice">
								<el-switch v-model="form.applyCompanyConfig.showPurchasePrice"></el-switch>
							</el-form-item>
							<el-form-item label="库存共享" prop="applyCompanyConfig.stockAutoShare">
								<el-switch v-model="form.applyCompanyConfig.stockAutoShare"></el-switch>
							</el-form-item>
							<el-form-item label="库存共享方式" prop="applyCompanyConfig.stockShareType" v-if="form.stockAutoShare">
								<el-select v-model="form.applyCompanyConfig.stockShareType">
									<el-option :key="0" label="不共享" :value="0"></el-option>
									<el-option :key="1" label="共享给全部公司" :value="1"></el-option>
									<el-option :key="2" label="共享给子公司" :value="2"></el-option>
								</el-select>
							</el-form-item>
						</el-tab-pane>
						<el-tab-pane label="统计信息" name="statTab" style="width:50%;margin-top:10px" v-if="controll['stat']">
							<el-form-item label="新报价周期开始日期" prop="applyCompanyConfig.superiorityRank">
								<el-date-picker
									type="date"
									placeholder="新报价周期开始日期"
									v-model="form.applyCompanyConfig.newestOfferPeriodStart"
									value-format="yyyy-MM-dd"
								></el-date-picker>
							</el-form-item>
							<el-form-item label="优势排名限定" prop="applyCompanyConfig.superiorityRank">
								<el-input v-model="form.applyCompanyConfig.superiorityRank" placeholder="设定前N名报价为优势报价"></el-input>
							</el-form-item>
							<el-form-item label="博弈显示记录数" prop="applyCompanyConfig.playChessItemLimit">
								<el-input v-model="form.applyCompanyConfig.playChessItemLimit" placeholder="博弈显示记录数"></el-input>
							</el-form-item>
						</el-tab-pane>
						<el-tab-pane label="控制参数" name="controlTab" style="width:50%;margin-top:10px" v-if="controll['control']">
							<el-form-item label="出库条件" prop="applyCompanyConfig.outStockCondition">
								<el-select v-model="form.applyCompanyConfig.outStockCondition">
									<el-option :key="0" label="上传支付凭证即可出库" :value="0"></el-option>
									<el-option :key="1" label="财务确认到账后才能出库" :value="1"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="账期金额上限" prop="applyCompanyConfig.periodAmountLimit">
								<el-input v-model="form.applyCompanyConfig.periodAmountLimit" placeholder="账期金额上限"></el-input>
							</el-form-item>
							<el-form-item label="账期周期上限" prop="applyCompanyConfig.periodDaysLimit">
								<el-input v-model="form.applyCompanyConfig.periodDaysLimit" placeholder="账期周期上限"></el-input>
							</el-form-item>
							<el-form-item label="目标客户展示最低分数线" prop="applyCompanyConfig.minLine">
								<el-input v-model="form.applyCompanyConfig.minLine" placeholder="最低分数线"></el-input>
							</el-form-item>
							<el-form-item label="目标客户展示最高分数线" prop="applyCompanyConfig.maxLine">
								<el-input v-model="form.applyCompanyConfig.maxLine" placeholder="最高分数线"></el-input>
							</el-form-item>
						</el-tab-pane>
						<el-tab-pane label="邮箱服务" name="emailTab" style="width:100%;margin-top:10px" v-if="controll['mail']">
							<el-form-item label="启用邮件计划任务" prop="applyCompanyConfig.planBuildTaskEnable">
								<el-switch v-model="form.applyCompanyConfig.planBuildTaskEnable"></el-switch>
							</el-form-item>
							<el-form-item label="启用邮件发送任务" prop="applyCompanyConfig.emailSendTaskEnable">
								<el-switch v-model="form.applyCompanyConfig.emailSendTaskEnable"></el-switch>
							</el-form-item>
							<el-form-item label="启用邮箱服务自适配" prop="applyCompanyConfig.emailAdapterEnable">
								<el-switch v-model="form.applyCompanyConfig.emailAdapterEnable"></el-switch>&nbsp;&nbsp;<font color="red">启用会根据客户的企业邮箱选择合适的邮箱服务</font>
							</el-form-item>
							<el-form-item label="单次发送邮件数量" prop="applyCompanyConfig.emailSendLimit">
								<el-input v-model="form.applyCompanyConfig.emailSendLimit" placeholder="单次发送邮件数量" style="width:50%;"></el-input>
							</el-form-item>
							<el-form-item label="邮件签名" prop="applyCompanyTextConfig.emailSign">
								<quill-editor ref="mailTemplateEditor" v-model="form.applyCompanyTextConfig.emailSign" :options="mailSignOption"></quill-editor>
							</el-form-item>
						</el-tab-pane>
						<el-tab-pane label="html模板" name="htmlTab" style="width:100%;margin-top:10px" v-if="controll['html']">
							<el-tabs v-model="htmlActiveName" tab-position="right">
								<el-tab-pane label="基本信息" name="htmlBaseTab">
									<el-form-item label="图片服务器" prop="applyCompanyTextConfig.htmlImageHost">
										<el-input v-model="form.applyCompanyTextConfig.htmlImageHost" placeholder="请输入图片服务器"></el-input>
									</el-form-item>
									<el-form-item label="暂无图片" prop="applyCompanyTextConfig.htmlNoPictureUrl">
										<el-input v-model="form.applyCompanyTextConfig.htmlNoPictureUrl" placeholder="请输入暂无图片链接"></el-input>
									</el-form-item>
									<el-form-item label="产品显示限制" prop="applyCompanyTextConfig.htmlShowProductLimit">
										<el-input v-model="form.applyCompanyTextConfig.htmlShowProductLimit" placeholder="请输入产品显示限制"></el-input>
									</el-form-item>
									<el-form-item label="页面产品系列链接格式" prop="applyCompanyTextConfig.htmlProductSeriesLinkFormat">
										<el-input type=textarea :rows=10 v-model="form.applyCompanyTextConfig.htmlProductSeriesLinkFormat"> </el-input>
									</el-form-item>
									<el-form-item label="页面产品链接格式" prop="applyCompanyTextConfig.htmlProductLinkFormat">
										<el-input type=textarea :rows=10 v-model="form.applyCompanyTextConfig.htmlProductLinkFormat"> </el-input>
									</el-form-item>
								</el-tab-pane>
								<el-tab-pane label="产品系列HTML" name="applyCompanyTextConfig.htmlSeriesSourceTab">
									<el-input type=textarea :rows=23 v-model="form.applyCompanyTextConfig.htmlSeriesSource"> </el-input>
								</el-tab-pane>
								<el-tab-pane label="产品详情HTML" name="applyCompanyTextConfig.htmlProductSourceTab">
									<el-input type=textarea :rows=23 v-model="form.applyCompanyTextConfig.htmlProductSource"> </el-input>
								</el-tab-pane>
							</el-tabs>
						</el-tab-pane>
						
						<el-tab-pane label="API" name="apiTab" style="width:50%;margin-top:10px" v-if="controll['html']">
							<el-form-item label="地图API" prop="applyCompanyConfig.mapApiId">
								<el-select v-model="form.applyCompanyConfig.mapApiId">
									<el-option :key="0" label="百度地图" :value="0"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="地图AK" prop="applyCompanyConfig.mapApiAk">
								<el-input v-model="form.applyCompanyConfig.mapApiAk" placeholder="请输入地图AK"></el-input>
							</el-form-item>
							<el-form-item label="文字识别API" prop="applyCompanyConfig.ocrApiId">
								<el-select v-model="form.applyCompanyConfig.ocrApiId">
									<el-option :key="0" label="百度文字识别" :value="0"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="文字识别Api Key" prop="applyCompanyConfig.ocrApiAk">
								<el-input v-model="form.applyCompanyConfig.ocrApiAk" placeholder="请输入文字识别Api Key"></el-input>
							</el-form-item>
							<el-form-item label="文字识别Api Secret" prop="applyCompanyConfig.ocrApiSecret">
								<el-input v-model="form.applyCompanyConfig.ocrApiSecret" placeholder="请输入文字识别Api Secret"></el-input>
							</el-form-item>
						</el-tab-pane>
						
						<el-tab-pane label="提醒设置" name="notifyTab" style="margin-top:10px;width:70%" v-if="controll['html']">
							<div v-for="(item, index) in notifyPlanKV" :id="item.id" style="margin-left:100px;margin-top:20px;margin-bottom:20px;min-height:30px;width:100%;">
								<el-row>
									<el-col :span="3">
										<el-checkbox :title="item.remark" :label="item.id" :key="item.id" v-model="notifyConfig[item.id].checked"
										@change="checked => notifyCheckChange(checked, item.id)">{{planTypeFormattor(item.planTypeId)}}</el-checkbox>
									</el-col>
									<el-col :span="21">
										<el-form-item label="指派对象" prop="sendTo" 
										v-if="('sendTo' in notifyConfig[item.id]) && notifyConfig[item.id].checked">
											<el-cascader
												:options="sendToOptions"
												:props="props"
												collapse-tags
												v-model="notifyConfig[item.id].sendTo" style="width:350px;" filterable clearable>
											</el-cascader>
										</el-form-item>
										<div :ref="dynamicRefName(item.id)" :id="dynamicRefName(item.id)" style="float:left;width:calc(100% - 225px)">
										
										</div>
									</el-col>
								</el-row>
							</div>
						</el-tab-pane>
						
					</el-tabs>
					<el-form-item style="width:50%;margin-top:20px;text-align:right">
						<el-button type="primary" @click="onSubmit" v-if="controll['submit']" v-prevent-re-click>提交</el-button>
					</el-form-item>
                </el-form>
            </div>
        </div>
		
		<el-dialog v-dialogDrag :close-on-click-modal=false title="更多对公账号" :visible.sync="moreBankVisible" width="45%">
            <el-table
                :data="bankData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
				:cell-style="{padding:4+'px'}"
				stripe
            >
				<el-table-column prop="value" label="银行名称"></el-table-column>
				<el-table-column prop="content" label="银行账号"></el-table-column>
                <el-table-column label="操作" width="100" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            class="red"
                            @click="handleDeleteBank(scope.$index, scope.row)"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
			<div class="record-a-d">
				<el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    @click="handleAddBank"
                >添加记录</el-button>
			</div>
        </el-dialog>
		
		<el-dialog v-dialogDrag :close-on-click-modal=false title="添加对公账号" :visible.sync="bankInfoAddVisible" width="30%">
            <el-form ref="bankInfo" :model="bankInfo" label-width="80px" :rules="bankInfoRules">
                <el-form-item label="银行名称" prop="value">
                    <el-input v-model="bankInfo.value"></el-input>
                </el-form-item>
                <el-form-item label="银行账号" prop="content">
					<el-input v-model="bankInfo.content"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="bankInfoAddVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveBankInfo" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { getOwnCompany, updateOwnCompany, getEnumValueVC, getEnumByCode, getContractTemplate,
saveEnumValue, deleteEnumValue, getNotifyPlans, getNotifyPlanTypeKv, getDepartmentUserTree } from '../../../api/index';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor';
import {quillRedefine} from 'vue-quill-editor-upload'
export default {
    name: 'my-company',
    data() {
		let checkAmount = (rule, value, callback) => {
			const amountReg = /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/
			if (value) {
				setTimeout(() => {
					if (amountReg.test(value)) {
						callback()
					} else {
						callback(new Error('请输入正确的金额'))
					}
				}, 100)
			}
		}
		let checkProfit = (rule, value, callback) => {
			const amountReg = /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/
			if (value) {
				setTimeout(() => {
					if (amountReg.test(value)) {
						callback()
					} else {
						callback(new Error("请输入正确的最低利润率\(1.05:表示5个点利润\)"))
					}
				}, 100)
			} else {
				callback(new Error("请输入正确的最低利润率\(1.05:表示5个点利润\)"))
			}
		}
		let checkCostRate = (rule, value, callback) => {
			const amountReg = /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/
			if (value) {
				setTimeout(() => {
					if (amountReg.test(value)) {
						callback()
					} else {
						callback(new Error("请输入正确的比率\(1.01:表示上浮1个点，0.99表示下浮1个点\)"))
					}
				}, 100)
			} else {
				callback(new Error("请输入正确的比率\(1.01:表示上浮1个点，0.99表示下浮1个点\)"))
			}
		}
		let checkRate = (rule, value, callback) => {
			const amountReg = /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/
			if (value) {
				setTimeout(() => {
					if (amountReg.test(value)) {
						callback()
					} else {
						callback(new Error("请输入正确的税率"))
					}
				}, 100)
			} else {
				callback(new Error("请输入正确的税率"))
			}
		}
		let checkNoFormat = (rule, value, callback) => {
			if (value.indexOf('{date}') == -1) {
				callback(new Error("格式错误，缺少{date}"));
			}
			if (value.indexOf('{no}') == -1) {
				callback(new Error("格式错误，缺少{no}"));
			}
			if (value.length > 16) {
				callback(new Error("格式长度错误，最长16个字符"));
			}
			callback()
		}
        return {
            form: {
				
            },
            rules: {
                "applyCompanyConfig.fullName": [{ required: true, message: '公司全称不能为空', trigger: 'blur' }],
                "applyCompanyConfig.taxNo": [{ required: true, message: '税务登记号不能为空', trigger: 'blur' }],
				"applyCompanyConfig.address": [{ required: true, message: '注册地址不能为空', trigger: 'blur' }],
				"applyCompanyConfig.produceAddress": [{ required: true, message: '请输入生产经营地址', trigger: 'blur' }],
				"applyCompanyConfig.legalPerson": [{ required: true, message: '请输入法人', trigger: 'blur' }],
				contact: [{ required: true, message: '联系人不能为空', trigger: 'blur' }],
				tel: [{ required: true, message: '联系电话不能为空', trigger: 'blur' }],
				"applyCompanyConfig.freePostageAmount": [{required: true, validator:checkAmount, trigger: 'blur' }],
				"applyCompanyConfig.minProfit": [{required: true, validator:checkProfit, trigger: 'blur' }],
				"applyCompanyConfig.taxRate": [{required: true, validator:checkRate, trigger: 'blur' }],
				"applyCompanyConfig.cityAdditionalTaxRate": [{required: true, validator:checkRate, trigger: 'blur' }],
				"applyCompanyConfig.educationAdditionalTaxRate": [{required: true, validator:checkRate, trigger: 'blur' }],
				"applyCompanyConfig.localEducationAdditionalTaxRate": [{required: true, validator:checkRate, trigger: 'blur' }],
				"applyCompanyConfig.defaultCostRate": [{required: true, validator:checkRate, trigger: 'blur' }],
				"applyCompanyConfig.taxExcludedCostRate": [{required: true, validator:checkRate, trigger: 'blur' }],
				"applyCompanyConfig.industry": [{ required: true, message: '请输入所属行业', trigger: 'blur' }],
				"applyCompanyConfig.companyType": [{ required: true, message: '请输入企业登记注册类型', trigger: 'blur' }],
				"applyCompanyConfig.bankName": [{ required: true, message: '请输入对公银行名称', trigger: 'blur' }],
				"applyCompanyConfig.bankNo": [{ required: true, message: '请输入对公银行账号', trigger: 'blur' }],
				"applyCompanyConfig.taxationBureau": [{ required: true, message: '请输入主管税务机关', trigger: 'blur' }],
				"applyCompanyConfig.authorizedPerson": [{ required: true, message: '请输入财务授权人', trigger: 'blur' }],	
				"applyCompanyConfig.accountingNo": [{required: true, message: '请输入记账编号格式', trigger: 'blur' }],
				"applyCompanyConfig.reviewer": [{required: true, message: '请输入审核人', trigger: 'blur' }],
				"applyCompanyConfig.cashier": [{required: true, message: '请输入出纳人', trigger: 'blur' }],
				"applyCompanyConfig.purchaseContractTemplateId": [{ required: true, message: '请选择采购合同模板', trigger: 'blur' }],
				"applyCompanyConfig.purchaseContractNoFormat": [{ required: true, validator: checkNoFormat, trigger: 'blur' }],
				"applyCompanyConfig.shipmentContractTemplateId": [{ required: true, message: '请选择销售合同模板', trigger: 'blur' }],
				"applyCompanyConfig.shipmentContractNoFormat": [{ required: true, validator: checkNoFormat, trigger: 'blur' }],
				"applyCompanyConfig.quotationTemplateId": [{ required: true, message: '请选择报价单模板', trigger: 'blur' }],
				"applyCompanyConfig.quotationNoFormat": [{ required: true, validator: checkNoFormat, trigger: 'blur' }],
				"applyCompanyConfig.outStockTemplateId": [{ required: true, message: '请选择出货单模板', trigger: 'blur' }],
				"applyCompanyConfig.reconciliationTemplateId": [{ required: true, message: '请选择对账单模板', trigger: 'blur' }],
				"applyCompanyConfig.outStockNoFormat": [{ required: true, validator: checkNoFormat, trigger: 'blur' }],
				"applyCompanyConfig.logo": [{ required: true, message: 'logo不能为空', trigger: 'blur' }],
				"applyCompanyConfig.seal": [{ required: true, message: '印章不能为空', trigger: 'blur' }],
				"applyCompanyConfig.newestOfferPeriodStart": [{ required: true, message: '请选择最新报价周期开始日期', trigger: 'blur' }],
				"applyCompanyConfig.superiorityRank": [{ required: true, message: '优势排名设定不能为空', trigger: 'blur' }],
				"applyCompanyConfig.playChessItemLimit": [{ required: true, message: '博弈简易展示记录数不能为空', trigger: 'blur' }],
				"applyCompanyConfig.minLine": [{ required: true, message: '请输入最低分数线', trigger: 'blur' }],
				"applyCompanyConfig.maxLine": [{ required: true, message: '请输入最高分数线', trigger: 'blur' }],
				
				"applyCompanyConfig.emailServer": [{ required: true, message: '邮箱服务器不能为空', trigger: 'blur' }],
				"applyCompanyConfig.emailPort": [{ required: true,  message: '端口号不能为空', trigger: 'blur' }],
				"applyCompanyConfig.emailAccount": [{ required: true, message: '邮箱账号不能为空', trigger: 'blur' }],
				"applyCompanyConfig.emailPassword": [{ required: true, message: '邮箱密码不能为空', trigger: 'blur' }],
				"applyCompanyConfig.emailFrom": [{ required: true, message: '发件人不能为空', trigger: 'blur' }],
				"applyCompanyConfig.emailNickName": [{ required: true, message: '发件人昵称不能为空', trigger: 'blur' }],
				"applyCompanyConfig.emailTestTo": [{ required: true, message: '邮件测试接收地址不能为空', trigger: 'blur' }],
				
				"applyCompanyConfig.mailApiId": [{ required: true, message: '请选择邮件服务', trigger: 'blur' }],
				"applyCompanyConfig.mailApiLimit": [{ required: true, message: '请输入每日邮件限制', trigger: 'blur' }]
            },
			bankInfoRules:{
				value: [{ required: true, message: '请输入银行开户行', trigger: 'blur' }],
				content: [{ required: true, message: '请输入银行账号', trigger: 'blur' }]
			},
			activeName:"baseTab",
			resourcesActiveName:"registeredCapitalRuleTab",
			imgPrefix:"/image",
			uploadUrl : "/image/upload/10",
			logoFileList:[],
			sealFileList:[],
			shippingSealFileList:[],
			purchaseCode:1017,
			shipmentCode:1018,
			quotationCode:1019,
			outStockCode:1020,
			reconciliationCode:1026,
			bankCode:1004,
			purchaseContractTemplateKV:[],
			shipmentContractTemplateKV:[],
			quotationTemplateKV:[],
			outStockTemplateKV:[],
			reconciliationTemplateKV:[],
			bankData:[],
			htmlActiveName:"htmlBaseTab",
			moreBankVisible:false,
			bankInfo:{},
			bankInfoAddVisible:false,
			controll:{},
			templateActiveName:"templateSetTab",
			notifyPlanKV:[],
			notifyPlanTypeKV:[],
			notifyConfig:{},
			sendToOptions:[],
			props:{
				multiple:true,
				checkStrictly: false
			},
        };
    },
	components: {
		quillEditor,
		quillRedefine
	},
	created() {
		this.controll = getControll("my-company");
		let ckey = localStorage.getItem('ms_ckey');
		this.uploadUrl = "/image/upload/" + ckey + "/10";
		this.getNotifyPlanType();
		this.getAllNotifyPlans();
		this.getSendToUser();
		this.getContractTemplateKv();
		this.mailSignOption = quillRedefine({
			// 图片上传的设置
			uploadConfig: {
				action: this.imgPrefix + "/upload/" + ckey + "/20",  // 邮件图片地址
				res: (respnse) => {
					return this.imgPrefix + respnse.data
				},
				methods: 'POST',  // 可选参数 图片上传方式  默认为post
				name: 'img',  // 可选参数 文件的参数名 默认为img
				size: 4096,  // 可选参数   图片限制大小，单位为Kb, 1M = 1024Kb
				accept: 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon',  // 可选参数 可上传的图片格式
				placeholder: '邮件图片',  // 可选参数 富文本框内的提示语
			}
		})
    },
    methods: {
		getSendToUser() {
			getDepartmentUserTree().then(res => {
				if (res.code == 0 ) {
					this.sendToOptions = res.data;
				} else {
					this.$message.error("获取用户信息失败，" + res.message);
				}
			});
		},
		dynamicRefName(key) {
			return "config_" + key;
		},
		getCompanyInfo() {
			getOwnCompany().then(res => {
				this.logoFileList = [];
				this.sealFileList = [];
				this.shippingSealFileList = [];
				if (res.code == 0) {
					this.form = res.data;
					if (!this.form.applyCompanyTextConfig) {
						this.$set(this.form, "applyCompanyTextConfig", {});
					}
					if (!this.form.applyCompanyConfig) {
						this.$set(this.form, "applyCompanyConfig", {});
					}
					if (this.form.applyCompanyConfig.notifyConfig) {
						this.notifyConfig = JSON.parse(this.form.applyCompanyConfig.notifyConfig);
					}
					for (var i=0; i<this.notifyPlanKV.length; i++){
						if (this.notifyPlanKV[i].id in this.notifyConfig) {
							continue;
						}
						let configData = {"checked":false};
						if (this.notifyPlanKV[i].config) {
							let configs = JSON.parse(this.notifyPlanKV[i].config);
							for (var j=0; j<configs.length;j++){
								if ("type" in configs[j] && configs[j]["type"] == "check") {
									configData[configs[j].key] = "default" in configs[j]?configs[j]["default"]:false;
								} else {
									configData[configs[j].key] = configs[j].key=="sendTo"?[]:"";
								}
							}
						}
						this.$set(this.notifyConfig, this.notifyPlanKV[i].id, configData);
					}
					let logoJson = {};
					logoJson['url'] = this.imgPrefix + res.data.applyCompanyConfig.logo;
					this.logoFileList.push(logoJson);
					let sealJson = {};
					sealJson['url'] = this.imgPrefix + res.data.applyCompanyConfig.seal;
					this.sealFileList.push(sealJson);
					let shippingSealJson = {};
					shippingSealJson['url'] = this.imgPrefix + res.data.applyCompanyConfig.shippingSeal;
					this.shippingSealFileList.push(shippingSealJson);
					setTimeout(this.notifyDataBind, 500);
				} else {
					this.$message.error(res.message);
				}
			}); 
		},
		notifyDataBind() {
			for (let key in this.notifyConfig){
				let config = this.notifyConfig[key];
				if (config.checked) {
					this.notifyCheckChange(config.checked, key);
				}
			}
		},
		notifyCheckChange(checked, key){
			let content = "";
			if (checked) {
				for (var i = 0; i < this.notifyPlanKV.length; i++) {
					let config = this.notifyConfig[this.notifyPlanKV[i].id];
					if (this.notifyPlanKV[i].id == key && this.notifyPlanKV[i].config) {
						let configs = JSON.parse(this.notifyPlanKV[i].config);
						for (var j = 0; j < configs.length; j++) {
							if (configs[j].key == "sendTo") {
								if (!("sendTo" in this.notifyConfig[this.notifyPlanKV[i].id])) {
									this.notifyConfig[this.notifyPlanKV[i].id].sendTo = [];
								}
								continue;
							}
							
							content = content + "<div class=\"el-form-item el-form-item--small\"><label for=\"" + configs[j].key 
							+ "\" class=\"el-form-item__label\" style=\"width: 180px;\"" 
							+ (configs[j].remark?" title=\"" + configs[j].remark + "\"":"") + ">" + configs[j].name 
							+ "</label><div class=\"el-form-item__content\" style=\"margin-left: 180px;\">"
							+ "<div class=\"el-input el-input--small\">"
							if ("type" in configs[j] && configs[j]["type"] == "check") {
								content = content + "<input type=\"checkbox\" "
								+" id=\"" + configs[j].key + "\"" 
								+ (config[configs[j].key]?" checked":"") +">启用</input>"
							} else {
								content = content + "<input type=\"text\" autocomplete=\"off\""
								+ " placeholder=\"请输入" + configs[j].name + "\" class=\"el-input__inner\" id=\"" + configs[j].key 
								+ "\" value=\"" + config[configs[j].key] + "\">"
							}
							content = content + "</div></div></div>"
						}
					}
				}
			}
			let div = document.getElementById("config_"+key);
			div.innerHTML = content;
		},
		getAllNotifyPlans(){
			getNotifyPlans().then(res => {
				if (res.code == 0) {
					this.notifyPlanKV = res.data;
					this.getCompanyInfo();
				} else {
					this.$message.error(`获取提醒计划失败！` + res.message);
				}
			})
		},
		getNotifyPlanType(){
			getNotifyPlanTypeKv().then(res => {
				if (res.code == 0 ) {
					this.notifyPlanTypeKV = res.data;
				} else {
					this.$message.error("获取提醒类型失败！" + res.message);
				}
			});
		},
		planTypeFormattor(cellValue) {
			let index = this.notifyPlanTypeKV.findIndex(item => {
				if (item.key === cellValue) {
					return true;
				}
			});
			if (index === -1) return cellValue;
			return "启用" + this.notifyPlanTypeKV[index].value;
		},	
        onSubmit() {
			if (this.form["invoicingType"] == 1) {
				if (this.form["invoiceAmountMax"] == undefined || this.form["invoiceAmountMax"] == "") {
					this.$message.error('发票最大金额不能为空！');
					return;
				}
				if (this.form["taxProductName"] == undefined || this.form["taxProductName"] == "") {
					this.$message.error('商品税目不能为空！');
					return;
				}
				if (this.form["taxPriceType"] == undefined || this.form["taxPriceType"] == "") {
					this.$message.error('价格方式不能为空！');
					return;
				}
				if (this.form["taxVersion"] == undefined || this.form["taxVersion"] == "") {
					this.$message.error('税收分类编码版本号不能为空！');
					return;
				}
			}
			for (var i = 0; i < this.notifyPlanKV.length; i++) {
				if (this.notifyPlanKV[i].config) {
					let config = this.notifyConfig[this.notifyPlanKV[i].id];
					if (!config.checked) {
						continue;
					}
					let configs = JSON.parse(this.notifyPlanKV[i].config);
					for (var j = 0; j < configs.length; j++) {
						if (configs[j].key == "sendTo") {
							let len = config.sendTo.length;
							if (len == 0) {
								this.$message.error("请选择提醒对象");
								return;
							}
						} else {
							let ele = document.getElementById(configs[j].key);
							if (!ele) {
								this.$message.error("请输入" + configs[j].name);
								return;
							}
							if (configs[j].required && ele.value == ""){
								this.$message.error("请输入" + configs[j].name);
								return;
							}
							if (configs[j].type == "check") {
								this.$set(config, configs[j].key, ele.checked);
							} else {
								this.$set(config, configs[j].key, ele.value);
							}
						}
					}
					this.$set(this.notifyConfig, this.notifyPlanKV[i].id, config);
				}
			}
			this.$set(this.form.applyCompanyConfig, "notifyConfig", JSON.stringify(this.notifyConfig));
			this.$refs.form.validate(valid => {
				if (valid){
					updateOwnCompany(this.form).then(res => {
						if (res.code == 0) {
							this.$message.success('更新成功！');
						} else {
							this.$message.error(res.message);
						}
					}); 
				} else {
					this.$message.error('信息填写不完整！');
				}
            });
        },		
		//logo上传
		uploadLogoSuccess(response, file, fileList) {
			this.form.applyCompanyConfig.logo = response.data;
		},
		//删除logo图片
		handleLogoRemove(file, fileList) {
			if (!this.form.applyCompanyConfig.logo) {
				return;
			}
			removeImg([this.form.applyCompanyConfig.logo]).then(res => {
				if (res.code == 0 ) {
					this.$message.success("删除logo成功");
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
			});
		},
		//seal上传
		uploadSealSuccess(response, file, fileList) {
			this.form.applyCompanyConfig.seal = response.data;
		},
		//删除seal图片
		handleSealRemove(file, fileList) {
			if (!this.form.applyCompanyConfig.seal) {
				return;
			}
			removeImg([this.form.applyCompanyConfig.seal]).then(res => {
				if (res.code == 0 ) {
					this.$message.success("删除合同印章成功");
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
			});
		},
		//seal上传
		uploadShippingSealSuccess(response, file, fileList) {
			this.form.applyCompanyConfig.shippingSeal = response.data;
		},
		//删除seal图片
		handleShippingSealRemove(file, fileList) {
			if (!this.form.applyCompanyConfig.shippingSeal) {
				return;
			}
			removeImg([this.form.applyCompanyConfig.shippingSeal]).then(res => {
				if (res.code == 0 ) {
					this.$message.success("删除合同印章成功");
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
			});
		},
		getContractTemplateKv() {
			getContractTemplate().then(res => {
				if (res.code == 0) {
					this.purchaseContractTemplateKV = res.data[this.purchaseCode];
					this.shipmentContractTemplateKV = res.data[this.shipmentCode];
					this.quotationTemplateKV = res.data[this.quotationCode];
					this.outStockTemplateKV = res.data[this.outStockCode];
					this.reconciliationTemplateKV = res.data[this.reconciliationCode];
				} else {
					this.$message.error(`获取模板失败！` + res.message);
				}
			})
		},
		//更多对公账户
		handleMoreBrank() {
			getEnumByCode(this.bankCode).then(res => {
				if (res.code == 0) {
					this.bankData = res.data;
					this.moreBankVisible = true;
				} else {
					this.$message.error(`获取对公账户列表失败！` + res.message);
				}
			})
		},
		handleAddBank() {
			this.bankInfo = {};
			this.bankInfoAddVisible = true;
		},
		saveBankInfo() {
			this.$set(this.bankInfo, "enumCode", this.bankCode);
			this.$refs.bankInfo.validate(valid => {
				if (valid){
					saveEnumValue(this.bankInfo).then(res => {
						if (res.code == 0) {
							this.$message.success('添加成功！');
							this.bankInfoAddVisible = false;
							this.handleMoreBrank();
						} else {
							this.$message.error(res.message);
						}
					}); 
				} else {
					this.$message.error('信息填写不完整！');
				}
            });
		},
		handleDeleteBank(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            }).then(() => {
				deleteEnumValue([row.id]).then(res => {
					if (res.code == 0) {
						this.$message.success('删除成功');
						this.handleMoreBrank();
					} else {
						this.$message.error(`删除失败！` + res.message);
					}
				});
			})
			.catch(() => {});
		},
		beforeUpload(file){
			let limit = file.size / 1024 < 1024;
			if (!limit) {
			  this.$message.error('上传文件大小不能超过 1M');
			  return false;
			}
			return true;
		}
    }
};
</script>

<style>
	.record-a-d { 
		padding-top:20px;
	}
	
	.el-dialog__body {
		padding-bottom:80px;
	}
</style>